<div class="connection">
  @if (tooth?.is_connectable && hasOrderProducts) {
    <div
      [ngClass]="{
        'gray-circle': !tooth?.has_right_connection && !tooth?.has_left_connection,
        'blue-circle': tooth?.has_left_connection || tooth?.has_right_connection,
        'not-clickable': readonly,
      }"
      class="circle"
      (click)="toggleConnection($event)"></div>
  }

  @if (tooth?.is_connectable && hasOrderProducts) {
    <div
      [ngClass]="{
        'gray-bridge': hasGrayBridge,
        'blue-bridge': hasBlueBridge,
        'not-clickable': readonly,
      }"
      [pTooltip]="
        (hasBlueBridge
          ? 'dental.order.product_configuration.is_connected.connected'
          : 'dental.order.product_configuration.is_connected.disconnected'
        ) | translate
      "
      tooltipPosition="top"
      (click)="toggleConnection($event)"></div>
  }
</div>
